import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Link from '@mui/material/Link';
import ViewDoc from '../Modals/ViewDoc';

const Signup = ({ setCurrentUser, setShowAuth, setError, socket }) => {

    const [currentDoc, setCurrentDoc] = useState({
        show: false,
        noBuffer: true,
        data: {
            fileName: "TOS.pdf"
        }
    })

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        password: '',
        password2: '',
        tos: false,
        ip: null,
        geoData: []
    });

    const handleSubmit = e => {
        e.preventDefault();
        socket.emit('create user', formData);
        socket.on('new user', data => {
            localStorage.setItem('auth_token', data.jwt);
            localStorage.setItem('_id', data._id);
            setCurrentUser({ user: data, isAuthenticated: true });
            setShowAuth(false);
        });
        socket.on('error', data => {
            setError({ ...data, show: true });
        });
    }

    const { firstName, lastName, username, email, password, password2, tos } = formData;

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField label="First Name" value={firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} required fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField label="Last Name" value={lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} required fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField label="Callsign" value={username} onChange={e => setFormData({ ...formData, username: e.target.value.toUpperCase() })} required fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField label="Email address" type="email" value={email} onChange={e => setFormData({ ...formData, email: e.target.value })} required fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField label="Password" type="password" value={password} onChange={e => setFormData({ ...formData, password: e.target.value })} required fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField label="Confirm Password" type="password" value={password2} onChange={e => setFormData({ ...formData, password2: e.target.value })} required fullWidth />
                    </Grid>
                </Grid>

                <Divider />

                <FormControlLabel
                    control={<Switch checked={tos} onChange={() => setFormData({ ...formData, tos: !tos })} />}
                    label={
                        tos ? "Accepted Terms of Service" : (
                            <Link component="button" type="button" underline="hover" onClick={(e) => { e.preventDefault(); setCurrentDoc({ ...currentDoc, show: true }); }}>
                                Terms of Service
                            </Link>
                        )
                    }
                />

                <Button type="submit" variant="contained" size="large">Submit</Button>
            </Stack>
            <ViewDoc
                currentDoc={currentDoc}
                setCurrentDoc={setCurrentDoc}
                socket={socket}
            />
        </Box>
    )
}

export default Signup
